import { HttpParams } from '@angular/common/http'
import { Component, Input, OnDestroy, OnInit, WritableSignal } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { AutoSizeDirective, BaseComponent, FeatureType, Grid, ModalSize, QualityControlMechanical, VpJob } from '../../../shared'
import { ActionToolbarButtonsComponent } from '../../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { MechanicalModalComponent } from './mechanical-modal.component'

@Component({
    selector: 'app-quality-control-mechanical',
    templateUrl: './mechanical.component.html',
    standalone: true,
    imports: [
        FormsModule,
        WjGridModule,
        WjGridFilterModule,
        WjInputModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        AutoSizeDirective,
    ],
})
export class MechanicalComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() selectedJob!: WritableSignal<string>
    @Input() allJobs: VpJob[] = []

    grid: Grid<QualityControlMechanical>

    constructor() {
        super()
        this.grid = new Grid<QualityControlMechanical>(this.services)
            .setupModalEditing(
                this.services.data.qualityControlMechanicals,
                'Mechanical Quality Control',
                MechanicalModalComponent,
                () => new QualityControlMechanical(),
                this,
                ModalSize.large,
            )
            .filterBy(item => [item.boltNutWasherMaterialType, item.flangeTypeRequired])
            .withColumnFilters()
            .isReadOnly(true)
            .wrapColumnHeaders()

        this.grid.itemAdded.on(this.handleItemAdded.bind(this))
        this.grid.modified.on(this.refreshData.bind(this))
    }

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.FieldToolsPlansAndSpecsEdit])
    }

    get selectedJobName(): string {
        const jobId = this.selectedJob()
        if (!jobId) return ''
        const job = this.allJobs.find(j => j.id === jobId)
        return job ? `${job.id} ${job.name}` : jobId
    }

    ngOnInit() {}

    ngOnDestroy(): void {
        this.grid.itemAdded.off(this.handleItemAdded.bind(this))
        this.grid.modified.off(this.refreshData.bind(this))
        this.grid.destroy()
    }

    loadMechanicalData(jobId: string) {
        if (!jobId || jobId === '') {
            this.grid.items = []
            return
        }

        const params = new HttpParams().set('jobId', jobId)
        this.services.data.get<QualityControlMechanical[]>('api/QualityControlMechanical/GetByJob', params).subscribe({
            next: (result: QualityControlMechanical[]) => {
                this.grid.items = result || []
            },
            error: () => {
                this.services.notification.error('Failed to load mechanical data')
                this.grid.items = []
            },
        })
    }

    handleItemAdded(item: QualityControlMechanical) {
        item.job = this.selectedJob()
    }

    refreshData() {
        const jobId = this.selectedJob()
        if (jobId && jobId !== '') {
            this.loadMechanicalData(jobId)
        }
    }

    onGridInitialized() {
        // Grid initialized
    }
}
